import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { DirectDataInputProvider } from "presentation/store/DirectDataInput/DirectDataInputProvider";
import { ANAInfoWrapper } from "presentation/view/components/ANAInfo/ANAInfoWrapper";
import { MessageBarWrapper } from "presentation/view/components/MessageBarWrapper";
import { GridStyles } from "presentation/view/components/styled/NbisTable.styled";
import DirectDataInputMaintenance from "presentation/view/section/DirectDataInput/DirectDataInputMaintenance";

const DirectDataInputContMain = () => {
    return <ANAInfoWrapper permission={Permission.DIRECT_DATA_INPUT_MAINTENANCE}>
        <MessageBarWrapper>
            <DirectDataInputProvider>
                <GridStyles />
                <DirectDataInputMaintenance />
            </DirectDataInputProvider>
        </MessageBarWrapper>
    </ANAInfoWrapper>
}

export default DirectDataInputContMain;